import "./App.scss";
import { Route, Routes } from "react-router-dom";
import { ROUTES } from "./config/routes";
import LoginPage from './pages/login-page/LoginPage';
import RequireAuth from "./components/required-auth/RequiredAuth";
import attendanceRoutes from "./routes/attendance.routes";
import recruitmentRoutes from "./routes/recruitment.routes";
import Spinner from "./components/spinner/Spinner";
import loadable from "@loadable/component";
import LeanLayout from "./layouts/lean-layout/LeanLayout";

const loadableOptions = {
  fallback: <Spinner />
}
// }
const RegularizeStatus = loadable(() => import(/* webpackChunkName: "RegularizationStatus" */ "./pages/regularize/RegularizeStatus"), loadableOptions)
const Page404 = loadable(() => import(/* webpackChunkName: "Page404" */ "./pages/page404/Page404"), loadableOptions)
// const ClockOutReminderPage = loadable(() => import(/* webpackChunkName: "ClockOutReminderPage" */ "./pages/clockout-reminder-page/ClockOutReminderPage"), loadableOptions)

function App() {

  return (
    <Routes>
      <Route path={ROUTES.LOGIN} element={<LeanLayout />}>
        <Route index element={<LoginPage />}/>
      </Route>

      {/* Handle regularization statuses */}
      <Route path={ROUTES.REGULARIZE} element={<LeanLayout />}>
        <Route index element={<RegularizeStatus />} />
      </Route>

      {recruitmentRoutes}
      
      {/* These routes are protected by authentication, Pages like Dashboard etc should be defined under here */}
      <Route element={<RequireAuth navigateTo={ROUTES.LOGIN} />}>
        
        {attendanceRoutes}
      </Route>
      
      {/* Matcher for when no routes match. This must always be in the end cause of the wildcard * character */}
      {/* <Route path={ROUTES.REMINDER.ROOT} element={<ClockOutReminderPage />} /> */}
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
}

export default App;
